import React from "react";
import { Stage, Layer, Image as KImage, Text, Group } from "react-konva";
import EditableRect from "./shapes/EditableRect";
import EditableCircle from "./shapes/EditableCircle";
import AvatarPreview from "./shapes/AvatarPreview";
import useImage from "use-image";

export default function EditorCanvas({
  imgUrl,
  viewW,
  viewH,
  pxLayout,
  layout,
  preview,
  avatarPreviewUrl,
  img,
  sel,
  setSel,
  updatePct,
}) {
  if (!imgUrl || !img || !layout || !pxLayout) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  const makeText = (s, shape, weight, color) => {
    if (!shape) return null;
    return (
      <Text
        key={`${s}-${shape.x}-${shape.y}-${shape.w}-${shape.h}`}
        text={s}
        x={shape.x - shape.w / 2}
        y={shape.y - shape.h / 2}
        width={shape.w}
        height={shape.h}
        align="center"
        verticalAlign="middle"
        fontSize={Math.max(1, Math.floor(shape.h * 0.72))}
        fontFamily="sans-serif"
        fontWeight={String(weight || 700)}
        fill={color || "#fff"}
        listening={false}
      />
    );
  };

  return (
    <Stage
      width={viewW}
      height={viewH}
      onMouseDown={(e) => {
        if (e.target === e.target.getStage()) setSel(null);
      }}
    >
      <Layer>
        {/* Background image */}
        <KImage image={img} width={viewW} height={viewH} listening={false} />

        {/* Avatar */}
        {pxLayout.avatar && (
          <>
            <AvatarPreview circ={pxLayout.avatar} url={avatarPreviewUrl} />
            <EditableCircle
              circ={pxLayout.avatar}
              selected={sel === "avatar"}
              onSelect={() => setSel("avatar")}
              onChange={(sh) => updatePct("avatar", sh)}
            />
          </>
        )}

        {/* NAME */}
        {layout?.name && (
          <>
            <EditableRect
              shape={pxLayout.name}
              selected={sel === "name"}
              onSelect={() => setSel("name")}
              onChange={(sh) => updatePct("name", sh)}
            />
            {makeText(
              preview.name,
              pxLayout.name,
              layout.name?.weight,
              layout.name?.color
            )}
          </>
        )}

        {/* CODE */}
        {layout?.code && (
          <>
            <EditableRect
              shape={pxLayout.code}
              selected={sel === "code"}
              onSelect={() => setSel("code")}
              onChange={(sh) => updatePct("code", sh)}
            />
            {makeText(
              preview.code,
              pxLayout.code,
              layout.code?.weight,
              layout.code?.color
            )}
          </>
        )}

        {/* jobTitle */}
        {layout?.jobTitle && (
          <>
            <EditableRect
              shape={pxLayout.jobTitle}
              selected={sel === "jobTitle"}
              onSelect={() => setSel("jobTitle")}
              onChange={(sh) => updatePct("jobTitle", sh)}
            />
            {makeText(
              preview.jobTitle,
              pxLayout.jobTitle,
              layout.jobTitle?.weight,
              layout.jobTitle?.color
            )}
          </>
        )}

        {/* info */}
        {layout?.info && (
          <>
            <EditableRect
              shape={pxLayout.info}
              selected={sel === "info"}
              onSelect={() => setSel("info")}
              onChange={(sh) => updatePct("info", sh)}
            />
            {makeText(
              preview.info,
              pxLayout.info,
              layout.info?.weight,
              layout.info?.color
            )}
          </>
        )}

        {/* transaction */}
        {layout?.transaction && (
          <>
            <EditableRect
              shape={pxLayout.transaction}
              selected={sel === "transaction"}
              onSelect={() => setSel("transaction")}
              onChange={(sh) => updatePct("transaction", sh)}
            />
            {makeText(
              (preview.transactionTemplate || "").replace(
                "{{so_luong_giao_dich}}",
                preview.transactionCount || "01"
              ),
              pxLayout.transaction,
              layout.transaction?.weight,
              layout.transaction?.color
            )}
          </>
        )}

        {/* amount */}
        {layout?.amount && (
          <>
            <EditableRect
              shape={pxLayout.amount}
              selected={sel === "amount"}
              onSelect={() => setSel("amount")}
              onChange={(sh) => updatePct("amount", sh)}
            />
            {makeText(
              preview.amount,
              pxLayout.amount,
              layout.amount?.weight,
              layout.amount?.color
            )}
          </>
        )}
      </Layer>
    </Stage>
  );
}
